import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore/helpers.resolve-props';
import { selectors as profileSelectors } from '@clearscore/redux.profile';

const getRoutes = (state) => resolveProp('entities.routes.byId', state) || {};
const getRouteIdsByCategory = (state, { menu }) =>
    resolveProp(`entities.routeCategories.byId.${menu}.routes`, state) || [];

export default createSelector(
    getRoutes,
    getRouteIdsByCategory,
    profileSelectors.getStatus,
    (routes, routeIdsByCategory, { accountIDVStatus }) =>
        Object.values(routes).filter(
            ({ id, visibility }) =>
                routeIdsByCategory.includes(id) && (!visibility || visibility.includes(accountIDVStatus)),
        ),
);
